import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const defaultCallback = value => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(value)
    }
  }
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  instance.content = ''

  if (currentBox) {
    let options = currentBox.options
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop]
      }
    }

    if (options.callback === undefined) {
      instance.callback = defaultCallback
    }

    let oldCb = instance.callback
    instance.callback = (value, instance) => {
      oldCb(value, instance)
    }

    options.container.appendChild(instance.$el)

    Vue.nextTick(() => {
      instance.visible = true
    })
  }
}

const QuestionWangEditor = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (options.callback && !callback) {
    callback = options.callback
  }
  if (!options.container) {
    options.container = document.body
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionWangEditor.defaults, options),
    callback: callback,
  }

  showBox()
}

QuestionWangEditor.setDefaults = defaults => {
  QuestionWangEditor.defaults = defaults
}

QuestionWangEditor.open = (content, options) => {
  return QuestionWangEditor(_.merge({
    content,
  }, options))
}

QuestionWangEditor.close = () => {
  instance.visible = false
  currentBox = null
}

QuestionWangEditor.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default QuestionWangEditor
export { QuestionWangEditor }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-wang-editor/src/main.js